import React, { useMemo } from "react";
import { COUNTRIES_BY_DIAL_CODE } from "@/react/features/countriesByDialCode";
import Tooltip from "@8x8/oxygen-tooltip";
import styled from "styled-components";
import ReactCountryFlag from "react-country-flag";

const Flags = styled.div`
  display: flex;
  gap: 4px;
`;

export const getCountriesByCode = (countryCode) => {
  return COUNTRIES_BY_DIAL_CODE[`+${countryCode}`] || [];
};

export const CountryFlags = ({ countryCode }) => {
  const countriesDetails = useMemo(
    () => getCountriesByCode(countryCode),
    [countryCode]
  );

  /**
   * Since ReactCountryFlag sets default values for fontSize and lineHeight to
   * 1em using style attribute inside the span, it is impossible to overwrite
   * with classes without using the !important specifier.
   *
   * Directly using style is superior to class or even id
   * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_cascade/Specificity#inline_styles
   *
   * Using style={{...}} (recommended styling according to docs).
   */
  return (
    <Flags>
      {countriesDetails.map((country) => (
        <Tooltip title={country.name}>
          <ReactCountryFlag
            style={{ fontSize: "36px", lineHeight: "36px" }}
            countryCode={country.code}
          />
        </Tooltip>
      ))}
    </Flags>
  );
};
